import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "menu-tabs"
};
const _hoisted_2 = {
  class: "menu-content"
};
const _hoisted_3 = {
  class: "menu-content-section"
};
const _hoisted_4 = {
  class: "menu-content-section"
};
const _hoisted_5 = {
  class: "menu-content-section"
};
import { ref, reactive, inject } from 'vue';
import Enum from '@/classes/Enum';
import NavBarProductTile from './NavBarProductTile.vue';
import NavBarProductATUBanner from './NavBarProductATUBanner.vue';
import NavBarProductLinksList from './NavBarProductLinksList.vue';
import NavMenu from "./NavMenu.json";
import FocusTrap from './FocusTrap.vue';
export default {
  __name: 'NavBarProductSubmenu',
  setup(__props, {
    expose: __expose
  }) {
    const closeNavBar = inject('closeNavBar', () => {});
    const submenu = ref(null);
    const menuTiles = ref([]);
    const menuContent = ref([]);
    const MenuTabs = new Enum(["UNLIMITED", "AUTOTUNE", "VOCAL_CHAIN", "CREATIVE_EFFECTS"]);
    const state = reactive({
      activeTab: MenuTabs.UNLIMITED
    });
    const isActive = tab => {
      return state.activeTab.valueOf() == tab.valueOf();
    };
    const setActiveTab = (tab, e = null) => {
      if (!(e && e.type === "keydown")) {
        state.activeTab = tab;
        if (submenu.value.contains(document.activeElement)) {
          e?.target.focus();
        }
        return;
      }
      if (tab.valueOf() === state.activeTab.valueOf()) {
        menuContent.value[tab.valueOf()]?.triggerFocus();
        return;
      }
      state.activeTab = tab;
      setTimeout(() => {
        menuContent.value[tab.valueOf()]?.triggerFocus();
      }, 0); // Delay until next tick to ensure the focus is set after the DOM update
    };

    /**
     * Return to the specified Menu Tab and return focus to the respective column
     * 
     * @param tab {Enum} - The tab to return to
     */
    const returnToTab = tab => {
      menuTiles.value[tab.valueOf()]?.$el.focus();
    };

    /**
     * Reset active tab to default ATU tab
     */
    const resetActiveTab = () => {
      setTimeout(() => {
        setActiveTab(MenuTabs.UNLIMITED);
      }, 200); // Delay to allow for hover effect to complete; adjust as needed
    };
    __expose({
      resetActiveTab,
      mainCol: menuTiles
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "menu-container",
        ref_key: "submenu",
        ref: submenu
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(FocusTrap, {
        escCallback: _unref(closeNavBar)
      }, {
        default: _withCtx(() => [_createVNode(NavBarProductTile, {
          tabindex: "0",
          isActive: isActive(_unref(MenuTabs).UNLIMITED),
          image: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/navigation/autotune_unlimited_logo.webp",
          name: "AutoTune Unlimited",
          description: "Subscription with all 23 plugins and free upgrades",
          onMouseenter: _cache[0] || (_cache[0] = e => setActiveTab(_unref(MenuTabs).UNLIMITED, e)),
          onKeydown: [_cache[1] || (_cache[1] = _withKeys(e => setActiveTab(_unref(MenuTabs).UNLIMITED, e), ["enter"])), _cache[2] || (_cache[2] = _withKeys(e => {
            e.preventDefault();
            e.stopPropagation();
            setActiveTab(_unref(MenuTabs).UNLIMITED, e);
          }, ["right"]))],
          ref: el => menuTiles.value[_unref(MenuTabs).UNLIMITED.valueOf()] = el
        }, null, 8, ["isActive"]), _createVNode(NavBarProductTile, {
          tabindex: "0",
          isActive: isActive(_unref(MenuTabs).AUTOTUNE),
          image: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/navigation/autotune_editions_logo.webp",
          name: "AutoTune Editions",
          description: "Professional pitch correction plugins",
          onMouseenter: _cache[3] || (_cache[3] = e => setActiveTab(_unref(MenuTabs).AUTOTUNE, e)),
          onKeydown: [_cache[4] || (_cache[4] = _withKeys(e => setActiveTab(_unref(MenuTabs).AUTOTUNE, e), ["enter"])), _cache[5] || (_cache[5] = _withKeys(e => {
            e.preventDefault();
            e.stopPropagation();
            setActiveTab(_unref(MenuTabs).AUTOTUNE, e);
          }, ["right"]))],
          ref: el => menuTiles.value[_unref(MenuTabs).AUTOTUNE.valueOf()] = el
        }, null, 8, ["isActive"]), _createVNode(NavBarProductTile, {
          tabindex: "0",
          isActive: isActive(_unref(MenuTabs).VOCAL_CHAIN),
          image: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/navigation/ai_vocal_chain_logo.webp",
          name: "AI Vocal Chain",
          description: "Your intelligent vocal mixing assistant",
          onMouseenter: _cache[6] || (_cache[6] = e => setActiveTab(_unref(MenuTabs).VOCAL_CHAIN, e)),
          onKeydown: [_cache[7] || (_cache[7] = _withKeys(e => setActiveTab(_unref(MenuTabs).VOCAL_CHAIN, e), ["enter"])), _cache[8] || (_cache[8] = _withKeys(e => {
            e.preventDefault();
            e.stopPropagation();
            setActiveTab(_unref(MenuTabs).VOCAL_CHAIN, e);
          }, ["right"]))],
          ref: el => menuTiles.value[_unref(MenuTabs).VOCAL_CHAIN.valueOf()] = el
        }, null, 8, ["isActive"]), _createVNode(NavBarProductTile, {
          tabindex: "0",
          isActive: isActive(_unref(MenuTabs).CREATIVE_EFFECTS),
          image: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/navigation/creative_effects_logo.webp",
          name: "Creative Effects",
          description: "Voice modifiers, multi-effects, and more",
          onMouseenter: _cache[9] || (_cache[9] = e => setActiveTab(_unref(MenuTabs).CREATIVE_EFFECTS, e)),
          onKeydown: [_cache[10] || (_cache[10] = _withKeys(e => setActiveTab(_unref(MenuTabs).CREATIVE_EFFECTS, e), ["enter"])), _cache[11] || (_cache[11] = _withKeys(e => {
            e.preventDefault();
            e.stopPropagation();
            setActiveTab(_unref(MenuTabs).CREATIVE_EFFECTS, e);
          }, ["right"]))],
          ref: el => menuTiles.value[_unref(MenuTabs).CREATIVE_EFFECTS.valueOf()] = el
        }, null, 8, ["isActive"])]),
        _: 1
      }, 8, ["escCallback"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_Transition, {
        name: "fade-in-place"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [_createVNode(FocusTrap, {
          ref: el => menuContent.value[_unref(MenuTabs).UNLIMITED.valueOf()] = el,
          onKeydown: _cache[12] || (_cache[12] = _withKeys(e => {
            e.preventDefault();
            e.stopPropagation();
            returnToTab(_unref(MenuTabs).UNLIMITED);
          }, ["left"])),
          escCallback: () => returnToTab(_unref(MenuTabs).UNLIMITED)
        }, {
          default: _withCtx(() => [_createVNode(NavBarProductATUBanner, {
            class: "menu-content-section"
          })]),
          _: 1
        }, 8, ["escCallback"])], 512), [[_vShow, isActive(_unref(MenuTabs).UNLIMITED)]])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "fade-in-place"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_3, [_createVNode(FocusTrap, {
          ref: el => menuContent.value[_unref(MenuTabs).AUTOTUNE.valueOf()] = el,
          onKeydown: _cache[13] || (_cache[13] = _withKeys(e => {
            e.preventDefault();
            e.stopPropagation();
            returnToTab(_unref(MenuTabs).AUTOTUNE);
          }, ["left"])),
          escCallback: () => returnToTab(_unref(MenuTabs).AUTOTUNE)
        }, {
          default: _withCtx(() => [_createVNode(NavBarProductLinksList, {
            items: _unref(NavMenu).ATEditions
          }, null, 8, ["items"])]),
          _: 1
        }, 8, ["escCallback"])], 512), [[_vShow, isActive(_unref(MenuTabs).AUTOTUNE)]])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "fade-in-place"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(FocusTrap, {
          ref: el => menuContent.value[_unref(MenuTabs).VOCAL_CHAIN.valueOf()] = el,
          onKeydown: _cache[14] || (_cache[14] = _withKeys(e => {
            e.preventDefault();
            e.stopPropagation();
            returnToTab(_unref(MenuTabs).VOCAL_CHAIN);
          }, ["left"])),
          escCallback: () => returnToTab(_unref(MenuTabs).VOCAL_CHAIN)
        }, {
          default: _withCtx(() => [_createVNode(NavBarProductLinksList, {
            items: _unref(NavMenu).VocalChain
          }, null, 8, ["items"])]),
          _: 1
        }, 8, ["escCallback"])], 512), [[_vShow, isActive(_unref(MenuTabs).VOCAL_CHAIN)]])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "fade-in-place"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_5, [_createVNode(FocusTrap, {
          ref: el => menuContent.value[_unref(MenuTabs).CREATIVE_EFFECTS.valueOf()] = el,
          onKeydown: _cache[15] || (_cache[15] = _withKeys(e => {
            e.preventDefault();
            e.stopPropagation();
            returnToTab(_unref(MenuTabs).CREATIVE_EFFECTS);
          }, ["left"])),
          escCallback: () => returnToTab(_unref(MenuTabs).CREATIVE_EFFECTS)
        }, {
          default: _withCtx(() => [_createVNode(NavBarProductLinksList, {
            items: _unref(NavMenu).CreativeEffects
          }, null, 8, ["items"])]),
          _: 1
        }, 8, ["escCallback"])], 512), [[_vShow, isActive(_unref(MenuTabs).CREATIVE_EFFECTS)]])]),
        _: 1
      })])], 512);
    };
  }
};